<template>
  <select v-if="groups.length > 0" v-model="selected">
    <option disabled :value="null">Please select one</option>
    <option
      v-for="group of groups"
      :key="group.id"
      :value="group.id"
    >
      {{ group.campus.name }}
      {{ group.fiscalYear }}
      {{ group.semester.name }}
      {{ group.dayOfWeek | weekday }}
      Period{{ group.period }}
      {{ group.tutor.id }}
      {{ group.tutor.name }}
      {{ group.quarter }}
      {{ group.levelName }}
    </option>
  </select>

  <div v-else>
    No groups.
  </div>
</template>

<script lang="ts">
import { FiscalYearSemester, weekdayKey, Weekdays } from '@/store/common.types'
import { Group, GroupConditions } from '@/store/groups/types'
import { University } from '@/store/master/types'
import { Tutor } from '@/store/tutors/types'
import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator'

@Component({
  filters: {
    weekday(key: weekdayKey) {
      return Weekdays[key]
    },
  },
})
export default class SelectGroupIdInput extends Vue {
  @Prop() tutor?: Tutor

  @Prop() fiscalYearSemester?: FiscalYearSemester

  @Prop() university?: University

  @Prop() value?: string

  private groups: Group[] = []

  private get selected(): string|null {
    return this.value || null
  }

  private set selected(groupId: string|null) {
    this.$emit('input', groupId)
  }

  private mounted() {
    this.fetchGroups()
  }

  private fetchGroups() {
    const conditions: GroupConditions = {
      tutor: this.tutor || null,
      university: this.university || null,
      campuses: [],
      weekdays: [],
      periods: [],
      fiscalYearSemester: this.fiscalYearSemester || null,
      removedPagingLimit: true,
    }

    this.$store.dispatch('fetchGroups', { page: 1, conditions, isUpdateState: false })
      .then((groups: Group[]) => {
        this.groups = groups
      })
  }
}
</script>

<style scoped>
  select{
    padding: 5px;
    border: 1px solid #AAAFB6;
    border-radius: 30px;
    width: 100%;
  }
</style>
